import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../"
import { OrderSearchHit, ShopperInsightsSearchHitCheckout, ShopperInsightsSearchHitSession } from "lib/types/generated/graphql-types"

const selectCustomer= (state: RootState): {
  email: string,
  orders: OrderSearchHit[] | undefined,
  checkouts: ShopperInsightsSearchHitCheckout[],
  sessions: ShopperInsightsSearchHitSession[]
} => state.customer

export const customerSelect  = createSelector(
  selectCustomer,
  (customer) => customer
)

